<div class="toast-container" *ngIf="toastGlobalService?.toasts?.length > 0">
    <app-toast [className]="toast.classname" *ngFor="let toast of toastGlobalService.toasts" [autohide]="true"
        [delay]="toast.delay || 3000" (hidden)="toastGlobalService.remove(toast)">{{toast.message}}
    </app-toast>
</div>